import { Routes, Route } from 'react-router-dom';
import CreateVendorLocation from './CreateVendorLocation';
import EditVendorLocation from './EditVendorLocaton';
import VendorLocationsList from './VendorLocationsList';

interface VendorLocationsProps {
  userType: string;
  currentPage: string;
  currentTab: string;
  setCurrentTab: (tab: string) => void;
  subTab: string;
  setSubTab: (tab: string) => void;
}

function VendorLocations({
  userType,
  currentPage,
  currentTab,
  setCurrentTab,
  subTab,
  setSubTab,
}: VendorLocationsProps) {
  const props = {
    userType,
    currentPage,
    currentTab,
    setCurrentTab,
    subTab,
    setSubTab,
  };
  return (
    <Routes>
      <Route path="/" element={<VendorLocationsList {...props} />} />
      <Route path="create" element={<CreateVendorLocation {...props} />} />
      <Route path="edit/:location_id" element={<EditVendorLocation />} />
    </Routes>
  );
}

export default VendorLocations;
